import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const brandAssetSchema = z.object({
  asset_id: z.string(),
  name: z.string(),
  url: z.string(),
});

const storePageSchema = z.object({
  url: z.string(),
  name: z.string(),
});

const storeSchema = z.object({
  store_name: z.string(),
  store_pages: z.array(storePageSchema),
});

const storeDataResponseSchema = z.object({
  brand_assets: z.array(brandAssetSchema).optional(),
  brand_entity_id: z.string().nullable().optional(),
  store_pages: z.array(storeSchema),
});

export const storesApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getStoreData",
    method: "get",
    path: "/stores/",
    parameters: [
      {
        name: "entityid",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "pages_only",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "categoryid",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "market_place",
        type: "Query",
        schema: z.string(),
      },
    ],
    status: 200,
    response: storeDataResponseSchema,
  }).build(),
);
